module.exports = __webpack_public_path__ + "static/media/savestfee-icon.e164a017.svg";